export const WEB_APP_TYPE_ID = 1;
export const API_TYPE_ID = 2;
export const SCHEDULED_JOB_TYPE_ID = 3;
export const MOBILE_APP_TYPE_ID = 4;
export const WORKFLOW_TYPE_ID = 5;
